export const PRODUCTS = [
  'LiveChat',
  'ChatBot',
  'HelpDesk',
  'KnowledgeBase',
  'OpenWidget',
  'TeamChat',

  // Platform release: remember to comment out Platform before official release
  // cannot be handled by Unleash as it requires authentication
  // 'Platform',

  'PartnerProgram',
];
